import { gsap, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.config({ ignoreMobileResize: true });

if (window.innerWidth >= 1200) {
  ScrollTrigger.normalizeScroll(true);
}

const QUERY = '.site-animation';
const DELAY = 100;

/**
 * This feature is used to setup fade up animation
 * 
 * @class Animation
 * @param {string} [query]
 * @param {number} [delay]
 */

export default class Animation {
  constructor(query = QUERY, delay = DELAY) {
    const elements = document.querySelectorAll(query);
    if (!elements || !elements.length) return;

    this.elements = [...elements];
    this.query = query;
    this.delay = delay;

    this.init();
  }

  init() {
    this.elements.forEach((element) => {
      let { delay } = this;

      if (element.dataset && element.dataset.delay) delay = Number(element.dataset.delay);

      gsap.timeline({
        scrollTrigger: {
          trigger: element,
          start: 'top bottom',
          once: true,
          onEnter: () => {
            setTimeout(() => element.classList.add('animated'), delay);
          }
        }
      });
    });
  }
}

/**
 * Usage example
 * 
 * new Animation('.site-animation', 150);
 * 
 */
